export const ALTCHA_CDN_VERSION = '3';

const ALTCHA_CDN_BASE = `https://cdn.jsdelivr.net/npm/altcha@${ALTCHA_CDN_VERSION}/dist`;

export const ALTCHA_BUNDLE_URL = `${ALTCHA_CDN_BASE}/main/altcha.min.js`;

export const ALTCHA_WORKER_URL = `${ALTCHA_CDN_BASE}/workers/argon2id.js`;

export const CHALLENGE_ALGORITHM_PBKDF2 = 'PBKDF2/SHA-256';

export const CHALLENGE_ALGORITHM_ARGON2ID = 'ARGON2ID';

export const ALTCHA_WIDGET_CONFIGURATION = JSON.stringify({
  hideFooter: true,
  hideLogo: true,
  workers: 4,
});

export function altchaWidgetHtml(challengeUrl: string, indent = ''): string {
  return [
    `${indent}<altcha-widget`,
    `${indent}  challenge="${challengeUrl}"`,
    `${indent}  configuration='${ALTCHA_WIDGET_CONFIGURATION}'`,
    `${indent}></altcha-widget>`,
  ].join('\n');
}

// The bundle is an ES module, so the registration has to run after it inside the same module script.
export function argon2idRegistrationScript(indent = ''): string {
  return [
    `${indent}<script type="module">`,
    `${indent}  import '${ALTCHA_BUNDLE_URL}';`,
    `${indent}  $altcha.algorithms.set('ARGON2ID', () => new Worker(URL.createObjectURL(new Blob(`,
    `${indent}    ["importScripts('${ALTCHA_WORKER_URL}')"], { type: 'text/javascript' }))));`,
    `${indent}</script>`,
  ].join('\n');
}

export function captchaPromptInstructions(challengeUrl: string): string {
  return `Include a captcha widget using the following HTML code:

${altchaWidgetHtml(challengeUrl, '  ')}

IMPORTANT: For the captcha to work, you must include this script tag in the HTML head:
${argon2idRegistrationScript('  ')}

`;
}

export function registerArgon2id(): void {
  const { algorithms } = globalThis.$altcha;
  if (algorithms.has('ARGON2ID')) {
    return;
  }
  algorithms.set(
    'ARGON2ID',
    () =>
      new Worker(
        URL.createObjectURL(
          new Blob([`importScripts('${ALTCHA_WORKER_URL}')`], { type: 'text/javascript' })
        )
      )
  );
}
